"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useUserStore } from "@/providers/user-store-provider";
import type { UserType } from "@/types/auth";

export default function useUser() {
	const { replace } = useRouter();
	const { user, saveUser, clearUser } = useUserStore((state) => state);

	const logOut = useCallback(async () => {
		try {
			await fetch("/api/auth/logout", { method: "POST" });
		} catch (error) {
			console.error("Failed to log out", error);
		}
		localStorage.clear();
		clearUser();
		replace("/auth/login");
	}, [clearUser, replace]);

	const logIn = useCallback(
		(userData: UserType) => {
			saveUser(userData);
		},
		[saveUser],
	);

	return { user, logOut, logIn };
}
